import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { parse } from "marked";
import { useMemo } from "react";
export const Markdown = ({ content }) => {
    const html = useMemo(() => {
        return parse(content, { async: false });
    }, [content]);
    return (_jsxs(_Fragment, { children: [_jsx("style", { href: "mapka-markdown", precedence: "default", children: `
        .mapka-markdown pre {
          overflow-x: auto;
        }
      ` }), _jsx("div", { className: "mapka-markdown", dangerouslySetInnerHTML: { __html: html } })] }));
};
